import { Box } from "@mui/material";

export function NoPermissions() {
  return <Box>You don't have permissions to view this page</Box>;
}
